var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNmFilterMapL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-filter-map-nm-cls-1 {\n        fill: #58bcb7;\n      }\n\n      .dummy-widget-filter-map-nm-cls-1, .dummy-widget-filter-map-nm-cls-2, .dummy-widget-filter-map-nm-cls-3, .dummy-widget-filter-map-nm-cls-4, .dummy-widget-filter-map-nm-cls-5, .dummy-widget-filter-map-nm-cls-6, .dummy-widget-filter-map-nm-cls-7, .dummy-widget-filter-map-nm-cls-8, .dummy-widget-filter-map-nm-cls-9, .dummy-widget-filter-map-nm-cls-10, .dummy-widget-filter-map-nm-cls-11, .dummy-widget-filter-map-nm-cls-12, .dummy-widget-filter-map-nm-cls-13, .dummy-widget-filter-map-nm-cls-14 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-filter-map-nm-cls-2, .dummy-widget-filter-map-nm-cls-15 {\n        fill: #1e1e1e;\n      }\n\n      .dummy-widget-filter-map-nm-cls-16 {\n        clip-path: url(#dummy-widget-filter-map-nm-clippath);\n      }\n\n      .dummy-widget-filter-map-nm-cls-3, .dummy-widget-filter-map-nm-cls-17, .dummy-widget-filter-map-nm-cls-18 {\n        fill: none;\n      }\n\n      .dummy-widget-filter-map-nm-cls-4 {\n        fill: #4eb062;\n      }\n\n      .dummy-widget-filter-map-nm-cls-17 {\n        stroke: #fff;\n        stroke-width: 5px;\n      }\n\n      .dummy-widget-filter-map-nm-cls-17, .dummy-widget-filter-map-nm-cls-18, .dummy-widget-filter-map-nm-cls-15 {\n        stroke-miterlimit: 10;\n      }\n\n      .dummy-widget-filter-map-nm-cls-5 {\n        fill: #4a494a;\n      }\n\n      .dummy-widget-filter-map-nm-cls-19 {\n        clip-path: url(#dummy-widget-filter-map-nm-clippath-1);\n      }\n\n      .dummy-widget-filter-map-nm-cls-6 {\n        fill: #9161a4;\n      }\n\n      .dummy-widget-filter-map-nm-cls-7 {\n        fill: #f29c3f;\n      }\n\n      .dummy-widget-filter-map-nm-cls-18 {\n        stroke: #4a494a;\n      }\n\n      .dummy-widget-filter-map-nm-cls-8 {\n        fill: #393a3a;\n      }\n\n      .dummy-widget-filter-map-nm-cls-9 {\n        fill: #e6e6e4;\n      }\n\n      .dummy-widget-filter-map-nm-cls-10 {\n        fill: #49beed;\n      }\n\n      .dummy-widget-filter-map-nm-cls-11 {\n        fill: #3463ac;\n      }\n\n      .dummy-widget-filter-map-nm-cls-12 {\n        fill: #444;\n      }\n\n      .dummy-widget-filter-map-nm-cls-15 {\n        stroke: #2b2b2b;\n        stroke-width: .4px;\n      }\n\n      .dummy-widget-filter-map-nm-cls-13 {\n        fill: #1f1f1f;\n        isolation: isolate;\n        opacity: .7;\n      }\n\n      .dummy-widget-filter-map-nm-cls-14 {\n        fill: #719bd1;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-filter-map-nm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-3",
    x: 7.5,
    y: 7.5,
    width: 155.2,
    height: 155.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-filter-map-nm-clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-3",
    x: 11.5,
    y: 41.2,
    width: 94.6,
    height: 91.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-8",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-filter-map-nm-cls-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-15",
    x: 7.9,
    y: 33.4,
    width: 154.4,
    height: 103.3,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-filter-map-nm-cls-13",
    d: "M14.1-82.9h142.4c3.4,0,6.2,2.8,6.2,6.2V14.2c0,3.4-2.8,6.2-6.2,6.2H14.1c-3.4,0-6.2-2.8-6.2-6.2v-90.9c0-3.4,2.8-6.2,6.2-6.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-13",
    x: 7.7,
    y: 149.9,
    width: 154.8,
    height: 103.3,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-filter-map-nm-cls-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-15",
    x: 7.9,
    y: 33.6,
    width: 155.2,
    height: 102.3,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-12",
    x: 15.9,
    y: 41.4,
    width: 140.1,
    height: 86.8,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 15.9,
    y: 96.9,
    width: 140.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 27.5,
    y: 41.4,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 56.6,
    y: 41.4,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 71.7,
    y: 41.4,
    width: 5,
    height: 32.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 129.3,
    y: 41.4,
    width: 5,
    height: 46.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 57.1,
    y: 70.5,
    width: 34.1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 27.6,
    y: 111.4,
    width: 34.1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 85.7,
    y: 41.4,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 114.7,
    y: 41.4,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 143.8,
    y: 41.4,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 27.5,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 56.6,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 85.7,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 114.7,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-2",
    x: 143.8,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-14",
    cx: 150,
    cy: 94.8,
    r: 2.8
  }))), /*#__PURE__*/React.createElement("line", {
    className: "dummy-widget-filter-map-nm-cls-17",
    x1: 116.8,
    y1: 41.2,
    x2: 116.8,
    y2: 97.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "dummy-widget-filter-map-nm-cls-17",
    x1: 145.8,
    y1: 41.2,
    x2: 145.8,
    y2: 97.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "dummy-widget-filter-map-nm-cls-17",
    x1: 116.8,
    y1: 104.5,
    x2: 116.8,
    y2: 128.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "dummy-widget-filter-map-nm-cls-17",
    x1: 145.8,
    y1: 104.5,
    x2: 145.8,
    y2: 128.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-7",
    cx: 85.5,
    cy: 68.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-1",
    cx: 93,
    cy: 104.5,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-7",
    cx: 61.2,
    cy: 95.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-7",
    cx: 26.1,
    cy: 51.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-4",
    cx: 26.1,
    cy: 114.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-4",
    cx: 70,
    cy: 54,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-1",
    cx: 91.9,
    cy: 42,
    r: 3.8
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 112.4,
    y: 41.7,
    width: 44.3,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-9",
    x: 172.8,
    y: 51.6,
    width: 7.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-9",
    x: 172.8,
    y: 61.7,
    width: 7.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-9",
    x: 172.8,
    y: 71.7,
    width: 7.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-7",
    cx: 115.6,
    cy: 64.8,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 118.5,
    y: 62.5,
    width: 28.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 151.7,
    y: 62.3,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-10",
    cx: 115.6,
    cy: 76.4,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 118.5,
    y: 74.3,
    width: 28.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-18",
    x: 151.8,
    y: 74.2,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-4",
    cx: 115.6,
    cy: 88.2,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 118.5,
    y: 86,
    width: 28.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 151.7,
    y: 86,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-filter-map-nm-cls-11",
    cx: 115.5,
    cy: 99.9,
    rx: 2.1,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 119.2,
    y: 97.7,
    width: 27.8,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-18",
    x: 151.8,
    y: 97.7,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-6",
    cx: 115.6,
    cy: 111.7,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 119.6,
    y: 109.5,
    width: 27.6,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-18",
    x: 151.8,
    y: 109.1,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-nm-cls-1",
    cx: 115.6,
    cy: 123.4,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 119.6,
    y: 121.2,
    width: 27.9,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-nm-cls-5",
    x: 151.8,
    y: 121.2,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmFilterMapL);
export default __webpack_public_path__ + "static/media/nm_filter_map_l.fe4420b2.svg";
export { ForwardRef as ReactComponent };